import client from './';

const languages = {
  se: 'se-sv',
  dk: 'dk-da',
  no: 'no-no',
};

export const getCountries = async (lang) => {
  let api = `${window.location.origin}/v2/cms-www-api/data/geo/cep/?market=`;

  if (Object.keys(languages)?.includes(lang)) api += languages[lang];
  else api += 'lu-en';

  return await client(api, 'get');
};
